import { ArrowsLeftRight as ArrowLeftRight, CheckCircle as CheckCircle2, X } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { useTranslationV2 } from '@/hooks/useTranslationV2';
import { safeLocalGet, safeLocalSet } from '@/utils/ssr';

export const CompareInfoBanner = () => {
  const { t } = useTranslationV2('vehicles');
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(safeLocalGet('compare-banner-dismissed') === 'true');
  }, []);

  const handleDismiss = () => {
    safeLocalSet('compare-banner-dismissed', 'true');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="mb-6 p-4 bg-gradient-to-r from-primary/10 via-primary/5 to-background rounded-lg border-2 border-primary/20 animate-in fade-in slide-in-from-top-3 duration-500">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 p-2 bg-primary/10 rounded-lg">
          <ArrowLeftRight className="w-5 h-5 text-primary" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-semibold text-lg mb-2">
            {t('compare_banner_title')}
          </h3>
          <div className="space-y-2 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
              <span>{t('compare_banner_step1')} <ArrowLeftRight className="inline w-4 h-4 mx-1" /> {t('compare_banner_step1_suffix')}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
              <span>{t('compare_banner_step2')}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
              <span>{t('compare_banner_step3')}</span>
            </div>
          </div>
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={handleDismiss}
          className="flex-shrink-0"
          aria-label={t('compare_banner_close')}
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
